import styled, { css } from 'styled-components';

export const SquareAspectIcon = styled.div<{ isSelected?: boolean }>`
  border: 1px solid
    ${({ isSelected }) =>
      isSelected ? 'var(--accent)' : 'var(--text-secondary)'};
  width: 8px;
  height: 8px;
  border-radius: 1px;
`;

export const VerticalAspectIcon = styled.div<{ isSelected?: boolean }>`
  border: 1px solid
    ${({ isSelected }) =>
      isSelected ? 'var(--accent)' : 'var(--text-secondary)'};
  width: 6px;
  height: 10px;
  border-radius: 1px;
`;

export const HorizontalAspectIcon = styled(VerticalAspectIcon)`
  transform: rotate(90deg);
`;

export const CaretDownIcon = () => (
  <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
    <path d="M9 5.5L5 1.5L1 5.5" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const DropdownIcon = styled.div<{ isOpen: boolean }>`
  width: 10px;
  height: 6px;
  margin-left: auto;
  display: flex;
  color: var(--accent);

  ${props =>
    !props.isOpen &&
    css`
      rotate: 180deg;
    `}
`;

export const SelectedAspectRatio = styled.span`
  color: var(--text-secondary);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  line-height: 100%;
  transition: color var(--transition-fast);
`;

export const AspectItem = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: max-content;
  padding: 4px 8px;
  border-radius: var(--radius);
  border: none;
  cursor: pointer;
  transition: all 150ms ease-out;

  &:hover {
    background-color: var(--surface-elevated);

    ${SelectedAspectRatio} {
      color: var(--foreground);
    }
  }

  &:active {
    background-color: var(--gray-700);
    scale: 0.98;
  }
`;

export const AspectItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 12px;
`;

export const AspectRatioLogo = styled.div`
  min-width: 10px;
  min-height: 10px;
  max-width: 14px;
  max-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

/* Open-menu panel per docs/design-system.md "Dropdown / Popover Menus":
   rounded-row menu — small container padding + row gap, no divider lines. */
export const AspectDropDown = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: absolute;
  z-index: 1000;
  top: 26px;
  left: 0;
  width: max-content;
  min-width: 105px;
  padding: 4px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--background);
  box-shadow: var(--elevation-toast);
`;

/* Menu-item row per the same standard: compact rounded row, resting
   --text-secondary, hover --surface-elevated + --foreground, selected value
   in --accent (gold — visual control). */
export const AspectRow = styled.div<{ isSelected: boolean }>`
  position: relative;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  white-space: nowrap;
  min-height: 32px;
  padding: 0 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: var(--text-xs);
  color: ${({ isSelected }) =>
    isSelected ? 'var(--accent)' : 'var(--text-secondary)'};
  gap: 8px;
  transition:
    background-color 120ms ease,
    color 120ms ease;

  &:hover {
    background-color: var(--surface-elevated);
    color: ${({ isSelected }) =>
      isSelected ? 'var(--accent)' : 'var(--foreground)'};
  }
`;
